module.exports = __webpack_public_path__ + "img/avatar1.dbd57ced.png";